export const EMPTY_MY_TOURNAMENTS_OVERVIEW = {
  student: null,
  dashboard: {
    total_tournaments: 0,
    upcoming_tournaments: 0,
    ongoing_tournaments: 0,
    completed_tournaments: 0,
    certificates_earned: 0,
    total_participations: 0,
  },
  summary: null,
  directory: [],
  timeline: [],
};
